module.exports = __webpack_public_path__ + "static/media/mac_guide.43335387.svg";